var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { staticClass: "unsynced-card", attrs: { "max-width": "960" } },
    [
      _c(
        "w-card-title",
        { attrs: { plain: "", subtitle: _vm.dossierName } },
        [
          _vm._v(" " + _vm._s(_vm.$ct("title-short")) + " "),
          _c("w-spacer"),
          _c("w-button", {
            attrs: { flat: "", round: "", icon: "times" },
            on: {
              click: function ($event) {
                return _vm.close()
              },
            },
          }),
        ],
        1
      ),
      _c(
        "w-card-content",
        { staticClass: "body" },
        [
          _c(
            "div",
            { staticClass: "toolbar" },
            [
              _c("w-segmented", {
                attrs: { items: _vm.tabItems },
                model: {
                  value: _vm.tab,
                  callback: function ($$v) {
                    _vm.tab = $$v
                  },
                  expression: "tab",
                },
              }),
              _c(
                "div",
                { staticClass: "toolbar-from" },
                [
                  _c("span", { staticClass: "toolbar-from-label" }, [
                    _vm._v(_vm._s(_vm.$ct("from"))),
                  ]),
                  _c("w-date-picker", {
                    on: {
                      input: function ($event) {
                        return _vm.load()
                      },
                    },
                    model: {
                      value: _vm.from,
                      callback: function ($$v) {
                        _vm.from = $$v
                      },
                      expression: "from",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c("p", { staticClass: "intro" }, [
            _vm._v(" " + _vm._s(_vm.$ct("intro")) + " "),
          ]),
          _vm.loading
            ? _c(
                "div",
                { staticClass: "state" },
                [_c("w-progress-circular", { attrs: { large: "" } })],
                1
              )
            : _vm.sending
            ? _c(
                "div",
                { staticClass: "state" },
                [
                  _c("w-fa", {
                    staticClass: "state-icon accent",
                    attrs: { icon: "cloud-upload-alt" },
                  }),
                  _c("div", { staticClass: "state-text" }, [
                    _vm._v(" " + _vm._s(_vm.$ct("sending")) + " "),
                  ]),
                  _vm.job
                    ? _c("w-progress-linear", {
                        staticClass: "state-progress",
                        attrs: { value: _vm.job.getProgressBarValue() },
                      })
                    : _vm._e(),
                ],
                1
              )
            : !_vm.documents.length
            ? _c(
                "div",
                { staticClass: "state" },
                [
                  _c("w-fa", {
                    staticClass: "state-icon ok",
                    attrs: { icon: "check-circle" },
                  }),
                  _c("div", { staticClass: "state-text" }, [
                    _vm._v(" " + _vm._s(_vm.$ct("empty")) + " "),
                  ]),
                ],
                1
              )
            : [
                _c(
                  "div",
                  { staticClass: "summary" },
                  [
                    _c("span", { staticClass: "summary-item" }, [
                      _c("b", [_vm._v(_vm._s(_vm.documents.length))]),
                      _vm._v(" " + _vm._s(_vm.$ct("summary-documents")) + " "),
                    ]),
                    _c("span", { staticClass: "summary-sep" }, [_vm._v("·")]),
                    _c("span", { staticClass: "summary-item" }, [
                      _c("b", [
                        _vm._v(_vm._s(_vm.formatMoney(_vm.totalAmount))),
                      ]),
                      _vm._v(" " + _vm._s(_vm.$ct("summary-total")) + " "),
                    ]),
                    _vm.failedCount
                      ? [
                          _c("span", { staticClass: "summary-sep" }, [
                            _vm._v("·"),
                          ]),
                          _c("span", { staticClass: "summary-item danger" }, [
                            _c("b", [_vm._v(_vm._s(_vm.failedCount))]),
                            _vm._v(
                              " " + _vm._s(_vm.$ct("summary-failed")) + " "
                            ),
                          ]),
                        ]
                      : _vm._e(),
                    _c("w-spacer"),
                    _vm.selectedCount
                      ? _c("span", { staticClass: "summary-item accent" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$ct("selected-count", {
                                  count: _vm.selectedCount,
                                })
                              ) +
                              " "
                          ),
                        ])
                      : _vm._e(),
                  ],
                  2
                ),
                _c("div", { staticClass: "table-scroll" }, [
                  _c("table", { staticClass: "doc-table" }, [
                    _c("thead", [
                      _c("tr", [
                        _c(
                          "th",
                          { staticClass: "check-col" },
                          [
                            _c("w-checkbox", {
                              attrs: { value: _vm.allSelected },
                              on: {
                                input: function ($event) {
                                  return _vm.toggleAll($event)
                                },
                              },
                            }),
                          ],
                          1
                        ),
                        _c("th", [_vm._v(_vm._s(_vm.$ct("col.date")))]),
                        _c("th", [_vm._v(_vm._s(_vm.$ct("col.number")))]),
                        _c("th", [_vm._v(_vm._s(_vm.$ct("col.contact")))]),
                        _c("th", { staticClass: "num" }, [
                          _vm._v(_vm._s(_vm.$ct("col.total"))),
                        ]),
                        _c("th", { staticClass: "status-col" }, [
                          _vm._v(_vm._s(_vm.$ct("col.status"))),
                        ]),
                      ]),
                    ]),
                    _c(
                      "tbody",
                      [
                        _vm._l(_vm.documents, function (d) {
                          return [
                            _c(
                              "tr",
                              {
                                key: _vm.keyOf(d),
                                staticClass: "doc-row",
                                class: { selected: _vm.isSelected(d) },
                                on: {
                                  click: function ($event) {
                                    _vm.toggle(d, !_vm.isSelected(d))
                                  },
                                },
                              },
                              [
                                _c(
                                  "td",
                                  {
                                    staticClass: "check-col",
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                      },
                                    },
                                  },
                                  [
                                    _c("w-checkbox", {
                                      attrs: { value: _vm.isSelected(d) },
                                      on: {
                                        input: function ($event) {
                                          return _vm.toggle(d, $event)
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c("td", { staticClass: "date-col" }, [
                                  _vm._v(_vm._s(_vm.formatDate(d.InvoiceDate))),
                                ]),
                                _c("td", { staticClass: "number-col" }, [
                                  _vm._v(
                                    " " + _vm._s(d.ComputedFriendlyID) + " "
                                  ),
                                  d.IsCreditNote
                                    ? _c("span", { staticClass: "cn-badge" }, [
                                        _vm._v(_vm._s(_vm.$ct("credit-note"))),
                                      ])
                                    : _vm._e(),
                                ]),
                                _c("td", { staticClass: "contact-col" }, [
                                  _vm._v(_vm._s(d.ContactName)),
                                ]),
                                _c("td", { staticClass: "num" }, [
                                  _vm._v(_vm._s(_vm.formatMoney(d.Total))),
                                ]),
                                _c(
                                  "td",
                                  { staticClass: "status-col" },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass: "pill",
                                        class: _vm.statusClass(d),
                                      },
                                      [
                                        _c("span", { staticClass: "pill-dot" }),
                                        _vm._v(
                                          _vm._s(_vm.statusLabel(d)) + " "
                                        ),
                                      ]
                                    ),
                                    d.LastError
                                      ? _c("w-button", {
                                          directives: [
                                            {
                                              name: "tooltip",
                                              rawName: "v-tooltip",
                                              value: _vm.$ct("show-error"),
                                              expression: "$ct('show-error')",
                                            },
                                          ],
                                          staticClass: "error-toggle",
                                          attrs: {
                                            flat: "",
                                            round: "",
                                            sm: "",
                                            icon:
                                              _vm.expandedKey === _vm.keyOf(d)
                                                ? "chevron-up"
                                                : "chevron-down",
                                          },
                                          on: {
                                            click: function ($event) {
                                              $event.stopPropagation()
                                              return _vm.toggleError(d)
                                            },
                                          },
                                        })
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ]
                            ),
                            _vm.expandedKey === _vm.keyOf(d) && d.LastError
                              ? _c(
                                  "tr",
                                  {
                                    key: _vm.keyOf(d) + "-err",
                                    staticClass: "error-row",
                                  },
                                  [
                                    _c(
                                      "td",
                                      { attrs: { colspan: "6" } },
                                      [
                                        _c("w-fa", {
                                          staticClass: "mrs",
                                          attrs: {
                                            icon: "exclamation-triangle",
                                          },
                                        }),
                                        _vm._v(_vm._s(d.LastError) + " "),
                                      ],
                                      1
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        }),
                      ],
                      2
                    ),
                  ]),
                ]),
                _vm.truncated
                  ? _c("p", { staticClass: "limit-hint" }, [
                      _vm._v(
                        " " + _vm._s(_vm.$ct("truncated", { count: 500 })) + " "
                      ),
                    ])
                  : _vm._e(),
              ],
        ],
        2
      ),
      !_vm.loading && !_vm.sending
        ? _c(
            "w-card-actions",
            { staticClass: "actions" },
            [
              _c(
                "div",
                { staticClass: "up-to" },
                [
                  _c("w-date-picker", {
                    attrs: { fancy: "", label: _vm.$ct("mark-up-to-date") },
                    model: {
                      value: _vm.upTo,
                      callback: function ($$v) {
                        _vm.upTo = $$v
                      },
                      expression: "upTo",
                    },
                  }),
                  _c(
                    "w-button",
                    {
                      attrs: {
                        ghost: "",
                        icon: "calendar-check",
                        disabled: !_vm.documents.length,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.markUpTo()
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.$ct("mark-up-to")) + " ")]
                  ),
                ],
                1
              ),
              _c("w-spacer"),
              _c(
                "w-button",
                {
                  staticClass: "cancel mr",
                  attrs: { icon: "check-double", disabled: !_vm.selectedCount },
                  on: {
                    click: function ($event) {
                      return _vm.markSelected()
                    },
                  },
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$ct("mark-selected", { count: _vm.selectedCount })
                      ) +
                      " "
                  ),
                ]
              ),
              _c(
                "w-button",
                {
                  attrs: {
                    icon: "cloud-upload-alt",
                    disabled: !_vm.selectedCount,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.sendSelected()
                    },
                  },
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$ct("send-selected", { count: _vm.selectedCount })
                      ) +
                      " "
                  ),
                ]
              ),
            ],
            1
          )
        : _c(
            "w-card-actions",
            { staticClass: "actions" },
            [
              _c("w-spacer"),
              _c(
                "w-button",
                {
                  staticClass: "cancel",
                  on: {
                    click: function ($event) {
                      return _vm.close()
                    },
                  },
                },
                [_vm._v(" " + _vm._s(_vm.$ct("close")) + " ")]
              ),
            ],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }